import React, {useEffect} from 'react';
import styles from "../CurrentProposal/CurrentProposal.module.css";
import GoBack from "../subsidiary/GoBack/GoBack";
import Loader from "../subsidiary/Loader/Loader";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {fetchCurrentPayments} from "../Payments/paymentsSlice";
import Sharing from "../Rating/Sharing";

function CurrentPayment(props) {
    const id = useParams().id
    const dispatch = useDispatch()
    const isLoaded = useSelector(state => state.paymentsSlice.isLoaded)
    const data = useSelector(state => state.paymentsSlice.currentPayment)
    const date = moment(data.created_at).format('DD MMM YYYY')
    const isPayment = window.location.pathname.split('/')[1] === 'payments'
    useEffect(() => {
        if (isPayment) {
            dispatch(fetchCurrentPayments(id))
        }
    },[dispatch, isPayment, id])

    return (
        <>
            {isLoaded && data.media ?
                <div className="content-wrapper">
                    <section className={styles.news + ' main'}>
                        <div className={styles.wrapper}>
                            <GoBack text={date} />
                            <div className={styles.img} style={{
                                background: `${data.media.image ? `linear-gradient(0deg, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(${data.media.image})` : 'black'}`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}>
                                <div style={{ padding: '30px' }}>
                                    <h1 className={styles.title}>
                                        {data.name}
                                    </h1>
                                    {/*<div className={styles.tags}>*/}
                                    {/*    {data.tags.map(tag => {*/}
                                    {/*        return <span className={styles.tag}>{tag.text}</span>*/}
                                    {/*    })*/}
                                    {/*    }*/}

                                    </div>
                                </div>
                            {/*</div>*/}
                            <div className="content-wrapper">
                                {/*<div className={styles.sharingContainer}>*/}
                                {/*    <Sharing position={'current'}/>*/}
                                {/*</div>*/}
                                {data.text ? <div dangerouslySetInnerHTML={{ __html: data.text }} className={styles.textContent}>
                                </div> : <div>Текста нет</div>}
                            </div>
                        </div>
                    </section>
                </div> : <Loader />}
        </>
    );
}

export default CurrentPayment;